namespace Gamification.Gamification {
    export namespace ProdottiEsperienzeTaskService {
        export const baseUrl = 'Gamification/ProdottiEsperienzeTask';

        export declare function Create(request: Serenity.SaveRequest<ProdottiEsperienzeTaskRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProdottiEsperienzeTaskRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProdottiEsperienzeTaskRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProdottiEsperienzeTaskRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/ProdottiEsperienzeTask/Create",
            Update = "Gamification/ProdottiEsperienzeTask/Update",
            Delete = "Gamification/ProdottiEsperienzeTask/Delete",
            Retrieve = "Gamification/ProdottiEsperienzeTask/Retrieve",
            List = "Gamification/ProdottiEsperienzeTask/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ProdottiEsperienzeTaskService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
